import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const MergeFieldHelp = () => {
    const { t } = useTranslation();

    return (
        <Typography variant="body2" color="textSecondary" sx={{ mt: 2, mb: 1 }}>
            {t('You can use the merge fields: {{examples}}.', { examples: '{contact.first-name} {contact.last-name} {contact.email} {contact.phone} {user.first-name} {user.last-name} {user.email}' })}
            {' '}
            {t('For each additional column present in the import, you can also use a merge field. For example, for the column "city," the merge field will be: {contact.city}.')}
        </Typography>
    );
};

export default MergeFieldHelp;
